var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      {
        staticClass:
          "box-typical box-typical-dashboard panel panel-default scrollable"
      },
      [
        _c("header", { staticClass: "box-typical-header panel-heading" }, [
          _c("h3", { staticClass: "panel-title" }, [_vm._v("Contacts")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "box-typical-body panel-body" }, [
          _c("div", { staticClass: "contact-row-list" }, [
            _c("article", { staticClass: "contact-row" }, [
              _c("div", { staticClass: "user-card-row" }, [
                _c("div", { staticClass: "tbl-row" }, [
                  _c("div", { staticClass: "tbl-cell tbl-cell-photo" }, [
                    _c("a", { attrs: { href: "#" } }, [
                      _c("img", {
                        attrs: { src: "img/photo-64-2.jpg", alt: "" }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell" }, [
                    _c("p", { staticClass: "user-card-row-name" }, [
                      _c("a", { attrs: { href: "#" } }, [_vm._v("Tim Collins")])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "user-card-row-mail" }, [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("timcolins@mail.com")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell tbl-cell-status" }, [
                    _vm._v("Director at Tony’s")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("article", { staticClass: "contact-row" }, [
              _c("div", { staticClass: "user-card-row" }, [
                _c("div", { staticClass: "tbl-row" }, [
                  _c("div", { staticClass: "tbl-cell tbl-cell-photo" }, [
                    _c("a", { attrs: { href: "#" } }, [
                      _c("img", {
                        attrs: { src: "img/photo-64-1.jpg", alt: "" }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell" }, [
                    _c("p", { staticClass: "user-card-row-name" }, [
                      _c("a", { attrs: { href: "#" } }, [_vm._v("Maggy Smith")])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "user-card-row-mail" }, [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("maggysmith@mail.com")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell tbl-cell-status" }, [
                    _vm._v("PR Manager")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("article", { staticClass: "contact-row" }, [
              _c("div", { staticClass: "user-card-row" }, [
                _c("div", { staticClass: "tbl-row" }, [
                  _c("div", { staticClass: "tbl-cell tbl-cell-photo" }, [
                    _c("a", { attrs: { href: "#" } }, [
                      _c("img", {
                        attrs: { src: "img/photo-64-3.jpg", alt: "" }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell" }, [
                    _c("p", { staticClass: "user-card-row-name" }, [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("Molly Bridjet")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "user-card-row-mail" }, [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("mollybr@mail.com")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell tbl-cell-status" }, [
                    _vm._v("Assistan")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("article", { staticClass: "contact-row" }, [
              _c("div", { staticClass: "user-card-row" }, [
                _c("div", { staticClass: "tbl-row" }, [
                  _c("div", { staticClass: "tbl-cell tbl-cell-photo" }, [
                    _c("a", { attrs: { href: "#" } }, [
                      _c("img", {
                        attrs: { src: "img/photo-64-4.jpg", alt: "" }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell" }, [
                    _c("p", { staticClass: "user-card-row-name" }, [
                      _c("a", { attrs: { href: "#" } }, [_vm._v("Maggy Smith")])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "user-card-row-mail" }, [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("maggysmith@mail.com")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell tbl-cell-status" }, [
                    _vm._v("PR Manager")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("article", { staticClass: "contact-row" }, [
              _c("div", { staticClass: "user-card-row" }, [
                _c("div", { staticClass: "tbl-row" }, [
                  _c("div", { staticClass: "tbl-cell tbl-cell-photo" }, [
                    _c("a", { attrs: { href: "#" } }, [
                      _c("img", {
                        attrs: { src: "img/photo-64-2.jpg", alt: "" }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell" }, [
                    _c("p", { staticClass: "user-card-row-name" }, [
                      _c("a", { attrs: { href: "#" } }, [_vm._v("Tim Collins")])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "user-card-row-mail" }, [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("timcolins@mail.com")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell tbl-cell-status" }, [
                    _vm._v("Director at Tony’s")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("article", { staticClass: "contact-row" }, [
              _c("div", { staticClass: "user-card-row" }, [
                _c("div", { staticClass: "tbl-row" }, [
                  _c("div", { staticClass: "tbl-cell tbl-cell-photo" }, [
                    _c("a", { attrs: { href: "#" } }, [
                      _c("img", {
                        attrs: { src: "img/photo-64-1.jpg", alt: "" }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell" }, [
                    _c("p", { staticClass: "user-card-row-name" }, [
                      _c("a", { attrs: { href: "#" } }, [_vm._v("Maggy Smith")])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "user-card-row-mail" }, [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("maggysmith@mail.com")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell tbl-cell-status" }, [
                    _vm._v("PR Manager")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("article", { staticClass: "contact-row" }, [
              _c("div", { staticClass: "user-card-row" }, [
                _c("div", { staticClass: "tbl-row" }, [
                  _c("div", { staticClass: "tbl-cell tbl-cell-photo" }, [
                    _c("a", { attrs: { href: "#" } }, [
                      _c("img", {
                        attrs: { src: "img/photo-64-3.jpg", alt: "" }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell" }, [
                    _c("p", { staticClass: "user-card-row-name" }, [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("Molly Bridjet")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "user-card-row-mail" }, [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("mollybr@mail.com")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell tbl-cell-status" }, [
                    _vm._v("Assistan")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("article", { staticClass: "contact-row" }, [
              _c("div", { staticClass: "user-card-row" }, [
                _c("div", { staticClass: "tbl-row" }, [
                  _c("div", { staticClass: "tbl-cell tbl-cell-photo" }, [
                    _c("a", { attrs: { href: "#" } }, [
                      _c("img", {
                        attrs: { src: "img/photo-64-4.jpg", alt: "" }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell" }, [
                    _c("p", { staticClass: "user-card-row-name" }, [
                      _c("a", { attrs: { href: "#" } }, [_vm._v("Maggy Smith")])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "user-card-row-mail" }, [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("maggysmith@mail.com")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tbl-cell tbl-cell-status" }, [
                    _vm._v("PR Manager")
                  ])
                ])
              ])
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-074d0d7d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-074d0d7d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/dashboard-elements/ListPanelComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-074d0d7d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/dashboard-elements/ListPanelComponent.vue
// module chunks = 0